// Astrea Ops Platform - Finance/Senior Management direct document upload
//
// The existing subcontractor flow (src/lib/pendingUploads.js) exists because an
// unauthenticated outside person needs a way in - a shareable token link, a
// pending_uploads review queue, and a Finance/Senior Management approval step
// before the file becomes a real `documents` row. None of that applies when the
// person doing the uploading is already signed-in Finance or Senior Management
// staff attaching a file straight onto a team member's profile: there is no one
// else who needs to review it, so this skips pending_uploads entirely and writes
// the `documents` row the moment the upload is confirmed. See
// api/staff-upload-init.js and api/staff-upload-confirm.js for the server side
// (both re-check the caller's role from their own profile row, the same pattern
// api/subcontractor-review-upload.js already uses - a client-claimed role would
// mean nothing).
//
// Reuses the same private `subcontractor-uploads` Storage bucket (no
// storage.objects policies at all - every read/write goes through a signed URL
// minted server-side with the service-role key) and the same
// uploadToSignedUrl() helper already exported by pendingUploads.js, just with a
// different path prefix so the two flows' files never collide.

import { supabase } from './supabaseClient';

export { uploadFileToSignedUrl } from './pendingUploads';

export async function staffUploadInit({ personId, file, category, note }) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not signed in.');
  const res = await fetch('/api/staff-upload-init', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session.access_token}` },
    body: JSON.stringify({
      personId,
      fileName: file.name,
      fileSize: file.size,
      mimeType: file.type,
      category: category || null,
      note: note || null,
    }),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.error || 'Could not start the upload.');
  return body;
}

export async function staffUploadConfirm({ personId, path, fileName, category, note }) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not signed in.');
  const res = await fetch('/api/staff-upload-confirm', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session.access_token}` },
    body: JSON.stringify({ personId, path, fileName, category, note }),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.error || 'The file did not finish uploading.');
  return body;
}
